import React from "react";
import Select from "react-select";
import { Option } from "../../types";
import "./index.scss";

interface CustomSelectProps {
  label?: string;
  name: string;
  id?: string;
  placeholder?: string;
  labelClassName?: string;
  className?: string;
  error?: string;
  value?: Option | Option[] | null;
  onChange?: (selectedOption: Option | Option[] | any) => void;
  handleInputChange?: (value: any) => void;
  required?: boolean;
  options: Option[];
  disabled?: boolean;
  customElement?: React.ReactNode;
  menuPlacement?: "auto" | "top" | "bottom"; // Add this prop for dropdown placement
  menuPosition?: "absolute" | "fixed";
  isClearable?: boolean;
  isMulti?: boolean;
  [key: string]: any; // To allow additional props
}

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: state.isFocused ? "1px solid black" : "1px solid black",
    boxShadow: state.isFocused ? "none" : "none",
    paddingLeft: "12px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    height: "100%",
    display: "flex",
    alignItems: "center",
    // padding: "0 8px",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    height: "100%",
    // position: "absolute",
    // top: "50%",
    // transform: "translateY(-50%)",
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#001751"
      : state.isFocused
        ? "#E0E0E0"
        : "#FFF",
    "&:hover": {
      backgroundColor: "#c8c8c8",
      color: "#363636",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: "#000", // Arrow color
    // padding: "0 8px", // Adjust padding if needed
  }),
};

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  name,
  id,
  placeholder = "Select...",
  labelClassName,
  className = "",
  error = "",
  value,
  onChange,
  handleInputChange,
  required = false,
  options,
  disabled = false,
  customElement = null,
  menuPlacement = "auto", // Default to auto placement
  menuPosition = "absolute", // Default to absolute positioning
  classNamePrefix = "Savitar",
  isClearable = false,
  isMulti = false,
  ...props
}) => {
  return (
    <div className={`form-control select ${className}`}>
      {label && (
        <label htmlFor={id} className={labelClassName}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div
        className={`relative react-select-box ${disabled ? "disabled" : ""}`}
        tabIndex={0}
        data-select
        data-name={name}
      >
        <Select
          {...props}
          id={id}
          name={name}
          value={value ?? null}
          onChange={onChange}
          options={options}
          styles={{ ...customStyles, ...props.styles }}
          placeholder={placeholder}
          onInputChange={handleInputChange}
          isDisabled={disabled}
          className={`${error ? "border-[red]" : ""} ${isMulti ? "multi-select" : ""}`}
          menuPlacement={menuPlacement} // Dynamically adjust dropdown placement
          menuPosition={menuPosition} // Use absolute or fixed positioning
          classNamePrefix={classNamePrefix}
          isClearable={isClearable}
          isMulti={isMulti}
        />
        {customElement}
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default CustomSelect;
